import apiClient from './apiClient';

export interface PriceListItem {
  id: number;
  part_number: string;
  description?: string | null;
  item_name?: string | null;
  category?: string | null;
  upc_code?: string | null;
  master_carton_qty?: number | null;
  us_list_price?: number | null;
  tier1_price?: number | null;
  tier2_price?: number | null;
  tier3_price?: number | null;
  tier4_price?: number | null;
  tier5_price?: number | null;
  dfp_cost?: number | null;
  is_active: boolean;
}

export interface ImportResult {
  created: number;
  updated: number;
  errors: string[];
}

const priceListApi = {
  list: (params?: { search?: string; category?: string; skip?: number; limit?: number }) =>
    apiClient.get<PriceListItem[]>('/price-list', { params }).then(r => r.data),

  search: (q: string, limit = 20) =>
    apiClient.get<PriceListItem[]>('/price-list/search', { params: { q, limit } }).then(r => r.data),

  searchAdvanced: (params: { q?: string; category?: string; description?: string; limit?: number }) =>
    apiClient.get<PriceListItem[]>('/price-list/search', { params }).then(r => r.data),

  batchLookup: (partNumbers: string[]) =>
    apiClient.post<PriceListItem[]>('/price-list/batch-lookup', partNumbers).then(r => r.data),

  categories: () =>
    apiClient.get<string[]>('/price-list/categories').then(r => r.data),

  create: (data: Partial<PriceListItem>) =>
    apiClient.post<PriceListItem>('/price-list', data).then(r => r.data),

  update: (id: number, data: Partial<PriceListItem>) =>
    apiClient.put<PriceListItem>(`/price-list/${id}`, data).then(r => r.data),

  import: (file: File) => {
    const formData = new FormData();
    formData.append('file', file);
    return apiClient.post<ImportResult>('/price-list/import', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }).then(r => r.data);
  },
};

export default priceListApi;
